import {
  GET_LIST_DANHSACHCUAHANG,
  GET_LIST_DANHSACHCUAHANG_SUCCESS,
  GET_LIST_DANHSACHCUAHANG_FAILURE,
} from "actions/DanhSachCuaHang/actionTypes";

const initialState = {
  getListDanhSachCuaHangLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListDanhSachCuaHang = (state, action) => ({
  ...state,
  getListDanhSachCuaHangLoading: true,
});

const getListDanhSachCuaHangSuccess = (state, action) => {
  return {
    ...state,
    getListDanhSachCuaHangLoading: false,
    objList: action.payload,
  };
};

const getListDanhSachCuaHangFailed = (state, action) => ({
  ...state,
  getListDanhSachCuaHangLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHCUAHANG:
      return getListDanhSachCuaHang(state, action);
    case GET_LIST_DANHSACHCUAHANG_SUCCESS:
      return getListDanhSachCuaHangSuccess(state, action);
    case GET_LIST_DANHSACHCUAHANG_FAILURE:
      return getListDanhSachCuaHangFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
